import Vuex from "vuex"
import Vue from "vue"
import stt from "./modules/stt"
import store_sv from './modules/store_sv'
import sysInit from "./modules/sysInit"
import discovery from "./modules/discovery"
import redmine from "./modules/redmine"
import echart from "./modules/echart"
import phone from "./modules/phone"
import openAi from "./modules/openAi"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    stt,
    sysInit,
    discovery,
    redmine,
    echart,
    store_sv,
    phone,
    openAi,
  }
});
